<template>
  <div class="flex items-start space-x-6">
    <aside
      class="
        border border-grey-500
        rounded
        max-w-xs
        w-full
        divide-y divide-grey-500
      "
    >
      <accordion-item v-if="showPublishers" class="relative px-4 py-3">
        <template :slot="'title'">
          <span class="text-base text-black-900 font-medium"> Publishers </span>
        </template>
        <template :slot="'content'">
          <select-input placeholder="Find Publishers" />
        </template>
      </accordion-item>
      <accordion-item class="relative px-4 py-3">
        <template :slot="'title'">
          <span class="text-base text-black-900 font-medium"> Date Added </span>
        </template>
        <template :slot="'content'">
          <checkbox-field class="mb-4" />
          <t-datepicker
            :monthsPerView="2"
            :multiple="true"
            :range="true"
            :weekStart="1"
            placeholder="Choose date or period"
            dateFormat="F j, Y"
          />
        </template>
      </accordion-item>
      <accordion-item class="relative px-4 py-3">
        <template :slot="'title'">
          <span class="text-base text-black-900 font-medium">
            Date Updated
          </span>
        </template>
        <template :slot="'content'">
          <checkbox-field class="mb-4" />
          <t-datepicker
            :monthsPerView="2"
            :multiple="true"
            :range="true"
            :weekStart="1"
            placeholder="Choose date or period"
            dateFormat="F j, Y"
          />
        </template>
      </accordion-item>
      <accordion-item class="relative px-4 py-3">
        <template :slot="'title'">
          <span class="text-base text-black-900 font-medium"> Viewed </span>
        </template>
        <template :slot="'content'">
          <checkbox-field />
        </template>
      </accordion-item>
    </aside>

    <main class="flex-1">
      <div class="grid grid-cols-2 gap-3">
        <card-catalog
          v-for="catalog in catalogsArray"
          :key="catalog.id"
          :catalogData="catalog"
        ></card-catalog>
      </div>

      <base-button class="mt-9">
        <svg
          class="mr-2"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 1V11M11 6L1 6"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
        </svg>
        Show more 24
      </base-button>
    </main>
  </div>
</template>

<script>
import CardCatalog from "@/components/cards/CardCatalog.vue";

export default {
  name: "TabCatalogs",
  components: {
    "card-catalog": CardCatalog,
    "base-button": () => import("@/components/utils/Button.vue"),
    "select-input": () => import("@/components/utils/SelectInput.vue"),
    "accordion-item": () => import("@/components/utils/AccordionItem.vue"),
    "checkbox-field": () => import("@/components/utils/CheckboxField.vue"),
  },
  props: {
    showPublishers: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      catalogsArray: [
        {
          id: 1,
          name: "Tinhead City, KL",
          imageURl: require("@/assets/new-catalogs/1.jpg"),
          catalogTitles: 15,
          epigram: "Epigram Books",
          createdAt: "June 22, 2020",
          updatedAt: "June 22, 2020",
        },
        {
          id: 2,
          name: "The Reading Tree",
          imageURl: require("@/assets/new-catalogs/2.jpg"),
          catalogTitles: 39,
          epigram: "Epigram Books",
          createdAt: "June 22, 2020",
          updatedAt: "June 22, 2020",
        },
        {
          id: 3,
          name: "The Keepers of Stories",
          imageURl: require("@/assets/new-catalogs/3.jpg"),
          catalogTitles: 15,
          epigram: "Epigram Books",
          createdAt: "June 22, 2020",
          updatedAt: "June 22, 2020",
        },
        {
          id: 4,
          name: "Tinhead City, KL",
          imageURl: require("@/assets/new-catalogs/4.jpg"),
          catalogTitles: 15,
          epigram: "Epigram Books",
          createdAt: "June 22, 2020",
          updatedAt: "June 22, 2020",
        },
      ],
    };
  },
};
</script>
